import React from 'react';
import PropTypes from 'prop-types';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import MetaControlField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import useEventTrackingLogEvent, { categories, eventTypes } from 'EventTracking/useEventTrackingLogEvent';
import { useSnackbarContext } from 'Context/SnackbarContext';
import {
  FDDialogActions,
  FDDialogContent, FDPrimaryActionButton, FDStack,
} from '@facet-wealth/design';

const Layout = ({ onSuccess }) => {
  const { onSubmit } = useMetaLayoutContext();
  const { displaySuccess } = useSnackbarContext();
  const { logStandardizedEvent } = useEventTrackingLogEvent();

  return (
    <>
      <MetaControlField attr={'title'} />
      <FDDialogContent>
        <FDStack direction={'column'} spacing={2}>
          <MetaControlField attr={'description'} />
          <MetaControlField attr={'currentPassword'} type="password" />
          <MetaControlField attr={'newPassword'} type="password" />
        </FDStack>
      </FDDialogContent>
      <FDDialogActions>
        <FDPrimaryActionButton
          label={'Continue'}
          fullWidth
          onClick={async () => {
            logStandardizedEvent(categories.userSettingsSecurity, eventTypes.clickButton, 'Auth Factor Password: Submit New Password');
            const resp = await onSubmit();
            if (resp) {
              onSuccess();
              displaySuccess('Password updated');
            }
          }}
          data-test={'security-settings-button-password-modify-modal-continue-1'}
        />
      </FDDialogActions>
    </>
  );
};

Layout.propTypes = {
  onSuccess: PropTypes.func.isRequired,
};

export default Layout;
